import { createContext} from 'react'

export const CitiesContext = createContext();